import React, { FC } from 'react'
import './AllianceFilterMovil.scss'
import { Accordion, Card } from 'react-bootstrap'
import { MdExpandMore } from 'react-icons/md'
import CheckBoxComponent from 'app_components/commons/checkBox/containers/checkBoxComponent'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { ILandingAlliance, TypeAgreement } from 'app_types/admin/landings/landingTypes'

interface IAllianceFilterMovilProps {
  agreements: string[]
  alliances: string[]
  handleClickMenu: (regional: string, agreement: ILandingAlliance["typeAgreement"]) => void
  isRegionalActive: (regional: string, agreement: ILandingAlliance["typeAgreement"]) => boolean
  onClose: () => void
  handleClickParentMenu: (agreement: ILandingAlliance["typeAgreement"]) => void
  parentRegional: TypeAgreement | undefined
}

const AllianceFilterMovil: FC<IAllianceFilterMovilProps> = ({
  agreements,
  alliances,
  handleClickMenu,
  isRegionalActive,
  onClose,
  handleClickParentMenu,
  parentRegional
}) => {

  const handleClickClear = () => {
    handleClickParentMenu("agreement")
    onClose()
  }

  return (
    <div className='alliance-filter-movil--layout'>
      <div className='alliance-filter-movil--title'>Filtrar resultados</div>
      {agreements?.length && (
        <Accordion>
          <Card style={{border: 'none'}}>
            <Accordion.Toggle as={Card.Header} eventKey="0" className='alliance-filter-movil--title-line' >
              <div
                onClick={() => handleClickParentMenu("agreement")}
                className='alliance-filter-movil--title-accordion'
                style={{
                  color: parentRegional === 'agreement' ? 'var(--secondary)' : undefined
                }}
              >
                Convenios
                <MdExpandMore color='gray'/>
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body className='alliance-filter-movil--alliances--big-container'>
                {agreements?.map((regional) => (
                  <div
                    onClick={() => handleClickMenu(regional, 'agreement')}
                    key={regional}
                    className='alliance-filter-movil--alliances-container'
                  >
                    <CheckBoxComponent
                      className='alliance-filter-movil--checkbox'
                      checked={isRegionalActive(regional, 'agreement')}
                      onClick={() => handleClickMenu(regional, 'agreement')}
                      radio
                    />
                    <p className='alliance-filter-movil--course-title'>{regional}</p>
                  </div>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
      {alliances?.length && (
        <Accordion>
          <Card style={{border: 'none'}}>
            <Accordion.Toggle as={Card.Header} eventKey="0" className='alliance-filter-movil--title-line' >
              <div
                onClick={() => handleClickParentMenu("alliance")}
                className='alliance-filter-movil--title-accordion'
                style={{
                  color: parentRegional === 'alliance' ? 'var(--secondary)' : undefined
                }}
              >
                Alianzas
                <MdExpandMore color='gray'/>
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body className='alliance-filter-movil--alliances--big-container'>
                {alliances?.map((alliance) => (
                  <div
                    key={alliance}
                    className='alliance-filter-movil--alliances-container'
                    onClick={() => handleClickMenu(alliance, 'alliance')}
                  >
                    <CheckBoxComponent
                      className='alliance-filter-movil--checkbox'
                      checked={isRegionalActive(alliance, 'alliance')}
                      onClick={() => handleClickMenu(alliance, 'alliance')}
                      radio
                    />
                    <p className='alliance-filter-movil--course-title'>{alliance}</p>
                  </div>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
        <div className='alliance-filter-movil--button-container'>
          <ButtonComponent
            className='alliance-filter-movil--buttons'
            onClick={handleClickClear}
          >
            Limpiar filtros
          </ButtonComponent>
          <ButtonComponent
            onClick={onClose}
            className='alliance-filter-movil--buttons'
            variant='secondary'
          >
            Aplicar
          </ButtonComponent>
        </div>
    </div>
  )
}

export default AllianceFilterMovil
